import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const serviceId = 5
const slug = 'network-cabling-and-home-automation-sydney';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Network Cabling & Home Automation Sydney | ${BUSINESS_NAME}`,
        description: "Professional data cabling, Wi-Fi optimisation, and smart home setup for seamless connectivity.",
        keywords: "network cabling Sydney, home automation Sydney, data cabling installation, Wi-Fi optimisation services, smart home setup, residential network solutions, commercial cabling services, structured cabling systems, smart lighting control, home security automation",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Network Cabling & Home Automation',
    description: 'Professional data cabling, Wi-Fi optimisation, and smart home setup for seamless connectivity.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
